import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function WhatDrivesUs() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  var plannerSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    // $(".header-mobile-menu").click(function () {
    // 	$(".nav-wrapper").toggleClass("show-menu");
    // });

    setTimeout(function () {
      $(".academy2").css("display", "none");
      $(".academy3").css("display", "none");
      $(".academy4").css("display", "none");
      $(".academy5").css("display", "none");
      $(".academy6").css("display", "none");
      $(".academy7").css("display", "none");
      $(".academy8").css("display", "none");
      $(".academy9").css("display", "none");
    }, 1000);

    $(".academybtncntr li").click(function () {
      $(".academybtncntr li").removeClass("active");
      $(this).addClass("active");

      if ($("#academy1").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy1").css("display", "block");
      }
      if ($("#academy2").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy2").css("display", "block");
      }
      if ($("#academy3").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy3").css("display", "block");
      }
      if ($("#academy4").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy4").css("display", "block");
      }
      if ($("#academy5").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy5").css("display", "block");
      }
      if ($("#academy6").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy6").css("display", "block");
      }
      if ($("#academy7").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy7").css("display", "block");
      }
      if ($("#academy8").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy8").css("display", "block");
      }
      if ($("#academy9").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy9").css("display", "block");
      }
    });
  });

  $(document).ready(function () {
    $(".facilities-view1").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view2").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view3").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view4").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view5").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view6").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view7").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view8").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view9").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item d-none">
                      <a href="/work-at-jio-institute">Work at Jio Institute</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      What Drives Us?
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <div
          data-bs-spy="scroll"
          data-bs-target="#navbar-example2"
          data-bs-offset="0"
          className="scrollspy-example"
          tabindex="0"
        >
          <section className="section-common-space overflow-hidden leadership-vision-section">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h1 class="subhead-bd text-primary-n label">
                    What Drives Us?
                  </h1>
                  <h2 className="h2-02 font-black mb-2 heading-container-sm m-auto">
                    LEADERSHIP & VISION
                  </h2>
                  <p>Work with global scholars and thought leaders</p>
                </div>
              </div>{" "}
              <div className="row slider-circle-panel pb-2 pt-4">
                <div className="col-12 text-center">
                  <div className="provos-section-slider equal_height_cards  justify-content-center text-center ">
                    {/* <Slider {...settings}> */}
                    <div className="row justify-content-around">
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="card h-100 border-0 radius-16 overflow-hidden">
                          <div className="rounded-circle img-dimension  overflow-hidden">
                            <img
                              src="assets/images/leader-image/Dr-Mashelkar_0.png.webp"
                              // src="https://www.jioinstitute.edu.in/sites/default/files/styles/webp/public/leader_image/Dr-Mashelkar_0.png.webp?itok=1FJQJYfw"
                              alt="about"
                              className="w-50 rounded-circle m-auto leaders-img"
                            />
                          </div>
                          <div className="card-body leader-card-body">
                            <div className="font-bold mb-2 primary text-uppercase body-02"></div>
                            <h4 className="font-bold f-24 leader-title ">
                              Dr. Raghunath Mashelkar
                            </h4>
                            <span className="profile-text overline-01 text-uppercase font-bold">
                              Chancellor
                            </span>

                            <p className="font-small ml-auto mr-auto mt-2 w-65">
                              Padma Vibhushan | Former Director General, CSIR,
                              Government of India
                            </p>
                          </div>
                          <div className="card-footer pt-0 border-0">
                            <a
                              href="https://www.jioinstitute.edu.in/about/chancellor"
                              className="btn btn-secondary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know more
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="card h-100 border-0 radius-16 overflow-hidden">
                          <div className="rounded-circle img-dimension  overflow-hidden">
                            <img
                              src="assets/images/leader-image/Dipak-Jain_1.png.webp"
                              // src="https://www.jioinstitute.edu.in/sites/default/files/styles/webp/public/leader_image/Dipak-Jain_1.png.webp?itok=MXpYvydw"
                              alt="about"
                              className="w-50 rounded-circle m-auto leaders-img"
                            />
                          </div>
                          <div className="card-body leader-card-body">
                            <div className="font-bold mb-2 primary text-uppercase body-02"></div>
                            <h4 className="font-bold f-24 leader-title">
                              Dr. Dipak Jain
                            </h4>
                            <span className="profile-text overline-01 text-uppercase font-bold">
                              VICE-CHANCELLOR
                            </span>

                            <p className="font-small ml-auto mr-auto mt-2 w-75">
                              Former Dean, Kellogg School of Management, USA |
                              Former Dean, INSEAD, France
                            </p>
                          </div>
                          <div className="card-footer pt-0 border-0 ">
                            <a
                              href="https://www.jioinstitute.edu.in/about/vice-chancellor"
                              className="btn btn-secondary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know more
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="section-common-space sectionnocolorbg section-container research-innovation-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-6" data-aos="fade-right">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/RESEARCH & INNOVATION.jpg"
                      alt="Research and Innovation"
                      className="w-100"
                    />
                  </div>
                  <h3 className="mt-4">RESEARCH & INNOVATION</h3>
                  <div className="body-02 section-copy">
                    <p>Research is at the core of Jio Institute’s vision.</p>
                    <p>
                      We are building a research-intensive ecosystem that
                      encourages inquiry, supports experimentation, and drives
                      innovation across disciplines.
                    </p>
                    <p>
                      Our focus includes emerging and impactful areas such as
                      technology, data sciences, sustainability, and societal
                      development.
                    </p>
                    <p>
                      We actively promote collaboration with industry,
                      government, and global academic institutions to ensure
                      that our research contributes to real-world solutions.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 mt-5 mt-lg-0" data-aos="fade-left">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/DIVERSITY, EQUITY & INCLUSION.jpg"
                      alt="Diversity, Equity & Inclusion"
                      className="w-100"
                    />
                  </div>
                  <h3 className="mt-4">DIVERSITY, EQUITY & INCLUSION</h3>
                  <div className="body-02 section-copy">
                    <p>
                      We believe that diversity is fundamental to innovation and
                      excellence.
                    </p>
                    <p>
                      Jio Institute is committed to fostering an inclusive
                      environment where individuals from diverse backgrounds
                      feel valued, respected, and empowered.
                    </p>
                    <p>
                      We actively seek to build a global community that reflects
                      a wide range of perspectives, experiences, and ideas.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-5 d-none">
                <div className="col-12 text-center">
                  <h3 className="h3-03 font-black mb-3">
                    VOICES FROM JIO INSTITUTE
                  </h3>
                  <p className="body-02 mx-auto research-summary">
                    Our people are at the heart of everything we do. Their
                    experiences reflect the collaborative, innovative, and
                    purpose-driven environment that defines Jio Institute. Our
                    people bring our vision to life.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default WhatDrivesUs;
